<template>
  <v-container>
    <v-row justify="space-between" align="center" class="mb-1">
      <v-col cols="auto">
        <v-switch class="ml-auto" v-model="isOpenGraph" inset label="Ver gráficas"></v-switch>
      </v-col>
      <v-col cols="12" md="auto">
        <v-row>
          <v-col cols="auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  v-bind="attrs"
                  v-on="on"
                  color="info"
                  @click="rangeDialogActive = true"
                  :loading="isDownloadingReport"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Descargar Reporte</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" md="auto">
            <v-text-field
              filled
              rounded
              dense
              v-model="searchQuery"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-card class="shadow-1">
      <v-card flat>
        <!-- Tabla -->
        <v-container v-if="!isOpenGraph">
          <vuescroll
            :ops="{
              bar: {
                background: '#bacfcec0',
                keepShow: true,
              },
            }"
          >
            <v-data-table
              :headers="callbackHeaders"
              :items="searchQuery.length > 0 ? filteredCallbackList : callbackList"
              class="elevation-0"
              :search="searchQuery"
              :loading="isLoading"
              :options.sync="options"
              :server-items-length="totalItems"
              :footer-props="{
                'items-per-page-options': [15, 30, 50, 100],
              }"
            >
              <template v-slot:[`item.number_phone`]="{ item }">
                <span class="d-inline pr-2" @click="getCallNow(item)" style="cursor: pointer">
                  {{ item.number_phone }}
                  <v-btn icon x-small>
                    <v-icon color="info" class="flip-icon">mdi-phone</v-icon>
                  </v-btn>
                </span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-hover v-slot:default="{ hover }">
                  <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="goToReport(item.id)">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </v-hover>
                <v-hover v-slot:default="{ hover }">
                  <v-tooltip bottom>
                    <template
                      v-slot:activator="{
                        on,
                        attrs,
                      }"
                    >
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        :color="hover ? 'accent' : 'blue-grey'"
                        @click.stop="openChangeStatusDialog(item)"
                      >
                        <v-icon>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Cambiar Estatus</span>
                  </v-tooltip>
                </v-hover>
              </template>
            </v-data-table>
          </vuescroll>
        </v-container>

        <!-- Graficas -->
        <v-container v-else fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" md="5">
              <v-card outlined>
                <v-card-title class="title text--primary mb-3" style="word-break: normal; line-height: normal;">
                  Llamadas por Estados
                </v-card-title>
                <v-card-text class="mb-2">
                  <apexchart type="donut" :options="donutChart.options" :series="donutChart.serie"></apexchart>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title class="title text--primary" style="word-break: normal; line-height: normal;">
                  Llamadas por Colas
                </v-card-title>
                <v-card-text>
                  <apexchart type="bar" :options="barChart.options" :series="barChart.serie"></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-card>

    <change-status-dialog
      v-if="isOpenChangeStatusDialog"
      :isOpen="isOpenChangeStatusDialog"
      :dataToEdit="dataToEdit"
      @dialog:change="closeChangeStatusDialog"
    ></change-status-dialog>

    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog
      v-if="rangeDialogActive"
      :active="rangeDialogActive"
      :id="id"
      module="ReportCallbacks"
      @dialog:change="eventdialog"
    ></RangeDateDialog>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";
import vuescroll from "vuescroll";
import moment from "moment";
import ChangeStatusDialog from "@/components/Callbacks/ChangeStatusDialog";
import RangeDateDialog from "@/components/DatePickers/DateRangePicker";

export default {
  components: { vuescroll, ChangeStatusDialog, RangeDateDialog },

  data() {
    return {
      rangeDialogActive: false,
      isDownloadingReport: false,
      isLoading: false,
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      searchQuery: "",
      isOpenChangeStatusDialog: false,
      isOpenGraph: false,
      callbackHeaders: [
        { text: "Numero de tlf", value: "number_phone", width: "20%" },
        { text: "Fecha de creado", value: "created_at", width: "15%" },
        {
          text: "Fecha de actualizado",
          value: "updated_at",
          width: "18%",
        },
        { text: "Cola", value: "queue_number", width: "15%" },
        { text: "Estado", value: "state", width: "20%" },
        // { text: "Acciones", value: "action", width: "15%" }
      ],
      callbackList: [],
      filteredCallbackList: [],
      dataToEdit: {},
      itemToCall: {},
      donutChart: {
        options: {
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: "100%",
                },
              },
            },
          ],
          width: "100%",
          legend: {
            position: "bottom",
          },
          labels: ["Entrantes", "Salientes"],
        },
        serie: [10, 20],
      },
      barChart: {
        options: {
          xaxis: {
            categories: [],
          },
          fill: {
            colors: ["#6D71F9"],
          },
        },
        serie: [
          {
            name: "Llamadas",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
    };
  },

  watch: {
    options: {
      handler() {
        this.getCallbacks();
      },
      deep: true,
    },
    searchQuery() {
      this.shallowSearch();
    },
    isInCall(val) {
      if (Object.keys(this.itemToCall).length && !val) this.openChangeStatusDialog(this.itemToCall);
    },
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isDark() {
      return this.$vuetify.theme.dark;
    },
    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
    hasRTC() {
      return !!this.ProfileInfo.web_rtc;
    },
    isInCall() {
      return this.$store.getters["dialer/GET_IS_IN_CALL"];
    },
  },

  created() {
    this.getCallbacks();
  },

  methods: {
    eventdialog() {
      this.rangeDialogActive = false;
    },

    normalizeDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },

    openChangeStatusDialog(item) {
      this.dataToEdit = item;
      this.isOpenChangeStatusDialog = true;
    },

    closeChangeStatusDialog(data) {
      if (data) this.callbackList = this.callbackList.map((el) => (el.id === data.id ? data : el));

      this.isOpenChangeStatusDialog = false;
      this.dataToEdit = {};
    },
    shallowSearch() {
      this.filteredCallbackList = this.callbackList.filter(
        (el) =>
          el.state.includes(this.searchQuery) ||
          String(el.number_phone).includes(this.searchQuery) ||
          String(el.queue_number).includes(this.searchQuery) ||
          String(el.created_at).includes(this.searchQuery) ||
          String(el.updated_at).includes(this.searchQuery),
      );
    },
    getValuesDonutChart(data) {
      let serieDonut = {};
      for (const el of data)
        if (!Object.hasOwnProperty.call(serieDonut, el.state)) serieDonut[el.state] = 1;
        else serieDonut[el.state] += 1;
      this.donutChart.options.labels = Object.keys(serieDonut);
      this.donutChart.serie = Object.values(serieDonut);
    },
    getValuesBarChart(data) {
      let serieBar = {};
      for (const el of data)
        if (!Object.hasOwnProperty.call(serieBar, el.queue_number)) serieBar[el.queue_number] = 1;
        else serieBar[el.queue_number] += 1;
      // console.log(serieBar);
      this.barChart.options.xaxis.categories = Object.keys(serieBar);
      this.barChart.serie[0].data = Object.values(serieBar);
    },
    async getCallbacks() {
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/call-back?page=${page}&itemPerPage=${itemsPerPage}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          this.callbackList = res.data.data;
          this.totalItems = res.data.total;
          this.getValuesDonutChart(res.data.data);
          this.getValuesBarChart(res.data.data);
          // console.log("res", res.data);
        })
        .catch((error) => {
          console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });

      // try {
      //     const { data } = await PbxHttpClient.get("call-back", {
      //         params: { page }
      //     });
      //     this.callbackList = data.data;
      //     this.getValuesDonutChart(data.data);
      //     this.getValuesBarChart(data.data);
      //     // console.log("res", data.data);
      // } catch (err) {
      //     console.log(err);
      //     this.$snotify.error(
      //         "Hubo un error cargando los datos.",
      //         "¡Error!"
      //     );
      // }
      // this.isLoading = false;
    },
    async getCallNow(item) {
      try {
        if (this.hasRTC) {
          this.itemToCall = { ...item };
          this.$store.dispatch("dialer/START_DIRECT_CALL", item.number_phone);
        } else {
          await PbxHttpClient.get(`call_now/${item.id}`);
          this.$snotify.success("Llamada realizada con éxito.", "¡Hecho!");
        }
        this.openChangeStatusDialog(item);
      } catch (err) {
        console.log("error calling now:", err);
        if (err.response) this.$snotify.error(err.response?.data?.error, "¡Error!");
        else this.$snotify.error("Hubo un error, intente mas tarde.", "¡Error!");
      }
    },
  },
};
</script>

<style>
.flip-icon {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
</style>
